var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getSuperThemeMode } from '../../../utils/theme';
var threeDsStyle = {
    borderRadius: 8,
    width: '-webkit-fill-available'
};
export default function Loader(_a) {
    var loading = _a.loading, themeMode = _a.themeMode, height = _a.height, is3ds = _a.is3ds, hideSpinnerLoader = _a.hideSpinnerLoader;
    return (_jsx("div", __assign({ style: __assign(__assign({ height: height - 2, display: loading ? 'flex' : 'none', justifyContent: 'center', alignItems: 'center', position: 'absolute', width: 'calc(100% - 20px)', zIndex: loading ? 1 : -1, margin: '8px 10px 8px 10px', borderRadius: 10 }, (loading && __assign(__assign({}, (is3ds && threeDsStyle)), { background: getSuperThemeMode(themeMode) === 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)', backdropFilter: 'blur(5px)', WebkitBackdropFilter: 'blur(5px)' }))), { transition: 'all ease-out 0.05s' }) }, { children: hideSpinnerLoader === true ? null : (_jsx("img", { height: 28, width: 28, src: getSuperThemeMode(themeMode) === 'light'
                ? 'https://tap-assets.b-cdn.net/gif/dark/tap-black-loader.gif'
                : 'https://tap-assets.b-cdn.net/gif/light/tap-white-loader.gif', alt: 'loading...' })) })));
}
